import Logocolor from "../Image/Logo.png";
import { Box, CircularProgress, Typography } from "@mui/material";

export const Loading = ({ text = "Cargando..." }) =>{
    return(
         <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "300px",
        gap: 2,
        position: "relative",
      }}
    >
      <CircularProgress
        size={90}
        thickness={4}
        sx={{ color: "#6fd385ff" }}
      />

      <Box
        component="img"
        src={Logocolor}
        alt="Logo"
        sx={{
          width: "55px",
          height: "55px",
          position: "absolute",
          top: "90px",
        }}
      />

      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: "18px",
          mt: 2,
        }}
      >
        {text}
      </Typography>
    </Box>
    )
}